import { ContactList } from "components/ui/ContactList";
import { MessagesSquare } from "lucide-react";
import { useOtherContacts } from "context/OtherContactsContext";
import { useEffect } from "react";
import { useAuth } from "context/AuthContext";

interface OtherContactsListProps {
  onSelectContact: (contactId: number) => void;
  selectedContactId: number | null;
}

export function OtherContactsList({
  onSelectContact,
  selectedContactId,
}: OtherContactsListProps) {
  const { otherContacts, loading, error, refresh, markContactAsRead } =
    useOtherContacts();
  const { lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleSelectContact = (contactId: number) => {
    markContactAsRead(contactId);
    onSelectContact(contactId);
  };

  const transformedRows = otherContacts.map((row) => ({
    id: row.contact.id,
    name: row.contact.name,
    subtitle: locale === "es" ? "Contacto general" : "General contact",
    lastMessageAt: row.lastMessageAt,
    hasUnread: row.hasUnread,
    replyMute: row.replyMute ?? null,
  }));

  return (
    <ContactList
      listId="other-contacts"
      title={locale === "es" ? "Otros" : "Others"}
      icon={<MessagesSquare className="w-4 h-4 mr-2" />}
      items={transformedRows}
      loading={loading}
      error={error}
      searchPlaceholder={
        locale === "es"
          ? "Buscar otros contactos..."
          : "Search other contacts..."
      }
      selectedId={selectedContactId}
      onSelectItem={handleSelectContact}
      getItemName={(item) => item.name}
      getItemSubtitle={(item) => item.subtitle}
    />
  );
}
